import { useEffect, useState } from "react";
import { Link, NavLink, Outlet } from "react-router-dom";
import { notificationsApi } from "../../lib/api/notifications.js";
import "./AppShell.css";

const NAV = [
  { to: "/app", end: true, label: "Map", icon: "🗺️" },
  { to: "/app/people", end: false, label: "People", icon: "👥" },
  { to: "/app/trips", end: false, label: "Trips", icon: "✈️" },
  { to: "/app/calendar", end: false, label: "Calendar", icon: "📅" },
  { to: "/app/hours", end: false, label: "Hours", icon: "🕑" },
  { to: "/app/profile", end: false, label: "Profile", icon: "🦫" },
];

export function AppShell() {
  const [unread, setUnread] = useState(0);
  useEffect(() => {
    notificationsApi.unreadCount().then((r) => {
      if (r.success && r.data) setUnread(r.data.unread);
    });
  }, []);

  return (
    <div className="shell">
      <header className="shell__top">
        <span className="brand brand--ink">
          <img src="/tatu.svg" alt="" aria-hidden="true" width={28} height={28} />
          Ondetatu
        </span>
        <Link
          to="/app/notifications"
          className="shell__bell"
          aria-label={`Notifications${unread ? `, ${unread} unread` : ""}`}
        >
          🔔{unread > 0 && <span className="shell__badge">{unread > 9 ? "9+" : unread}</span>}
        </Link>
      </header>

      <main className="shell__main">
        <Outlet />
      </main>

      <nav className="shell__nav" aria-label="Primary">
        {NAV.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            className={({ isActive }) => `shell__nav-item${isActive ? " is-active" : ""}`}
          >
            <span className="shell__nav-icon" aria-hidden="true">
              {item.icon}
            </span>
            <span className="shell__nav-label">{item.label}</span>
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
